<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form 
      ref="form" 
      :model="form" 
      :rules="rules" 
      label-width="100px"
      size="small"
    >
      <el-form-item label="投诉类型：" prop="type">
        <el-select
          v-model="form.type"
          placeholder="请选择投诉类型"
          style="width: 100%"
        >
          <el-option label="服务质量" value="服务质量"></el-option>
          <el-option label="环境卫生" value="环境卫生"></el-option>
          <el-option label="设备设施" value="设备设施"></el-option>
          <el-option label="安全管理" value="安全管理"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="状态：" prop="status" v-if="isEdit">
        <el-select
          v-model="form.status"
          placeholder="请选择状态"
          style="width: 100%"
          :disabled="!isEdit"
        >
          <el-option 
            v-for="option in statusOptions" 
            :key="option.value" 
            :label="option.label" 
            :value="option.value"
          />
        </el-select>
      </el-form-item>
      
      <el-form-item label="联系人：" prop="contact">
        <el-input
          v-model="form.contact"
          placeholder="请输入联系人"
          clearable
          maxlength="20"
          show-word-limit
        />
      </el-form-item>
      
      <el-form-item label="投诉内容：" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="5"
          placeholder="请详细描述投诉内容"
          clearable
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取消</el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit" 
        size="small"
        :loading="loading"
      >
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "PropertyComplaintDialog",
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      form: {
        id: '',
        type: '服务质量',
        content: '',
        contact: '',
        status: '待处理'
      },
      // 状态选项 - 确保 value 是数字类型
      statusOptions: [
        { label: '待受理', value: 1 },
        { label: '处理中', value: 2 },
        { label: '已办结', value: 3 },
        { label: '已撤销', value: 4 },
      ],
      rules: {
        type: [
          { required: true, message: '请选择投诉类型', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入投诉内容', trigger: 'blur' },
          { min: 10, max: 1000, message: '长度在 10 到 1000 个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    
    dialogTitle() {
      return this.isEdit ? '编辑投诉建议' : '新建投诉建议';
    }
  },
  // 计算当前状态的显示标签
    currentStatusLabel() {
      const option = this.statusOptions.find(opt => opt.value === this.form.status);
      return option ? option.label : '未知状态';
    },
  
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
        if (this.formData && Object.keys(this.formData).length > 0) {
            // 确保状态值是数字类型
          const statusValue = Number(this.formData.status);
          this.form = {
            id: this.formData.id || '',
            type: this.formData.type || '服务质量',
            content: this.formData.content || '',
            contact: this.formData.contact || '',
            status: isNaN(statusValue) ? 1 : statusValue // 确保是数字
          };
        }
        
        // 新增时默认为待处理状态
        if (!this.isEdit) {
          this.form.status = '待处理';
        }
        
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        });
      }
    }
  },
  
  methods: {
    resetForm() {
      this.form = {
        id: '',
        type: '服务质量',
        content: '',
        contact: '',
        status: '待处理'
      };
    },
    
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          
          // 发送保存事件
          this.$emit('save', { ...this.form });
          
          // 模拟异步操作
          setTimeout(() => {
            this.loading = false;
            this.handleClose();
          }, 500);
        } else {
          this.$message.warning('请正确填写表单');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-input,
.el-select,
.el-textarea {
  width: 100%;
}
</style>